export const currentCourseSelector = (state: any) => state.currentCourse;
